module.exports = __webpack_public_path__ + "static/media/9.b68045bb.png";